module.exports = __webpack_public_path__ + "img/bk-logo-yellow-icon.3c3cb209.svg";